/* eslint-disable */
import { useRef, useState, useEffect, useContext, useMemo } from "react";
import AuthContext from "../../../../context/AuthProvider";
import axios from "axios";
import Cookies from "js-cookie";
import * as Icon from "react-bootstrap-icons";
import logo from "../../../../assets/logo.png";
import "./Login.css";
import { useNavigate, Link, Outlet } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";

//Redux-imports
import { getLoginContent } from "../../../../redux/actions/loginActions";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { getPublicTenantBranding } from "../../../../api/customerSiaApi";

function trimStr(v) {
  return typeof v === "string" ? v.trim() : "";
}

/** Normalize branding from GET login, GET public/tenant-branding, or legacy shapes. */
function normalizeLoginBrandingPayload(raw) {
  if (raw == null) return null;
  let obj = raw;
  if (Array.isArray(raw)) {
    obj = raw.find((x) => x && typeof x === "object") ?? raw[0];
  }
  if (!obj || typeof obj !== "object") return null;
  const logo =
    trimStr(obj.logo) ||
    trimStr(obj.company_logo) ||
    trimStr(obj.companyLogo) ||
    trimStr(obj?.branding?.logo) ||
    trimStr(obj?.client_details?.company_logo);
  const primary_color =
    trimStr(obj.primary_color) ||
    trimStr(obj.primaryColor) ||
    trimStr(obj?.branding?.primary_color);
  const secondary_color =
    trimStr(obj.secondary_color) ||
    trimStr(obj.secondaryColor) ||
    trimStr(obj?.branding?.secondary_color);
  if (!logo && !primary_color && !secondary_color) return null;
  return { logo, primary_color, secondary_color };
}

/** Prefer first argument when a field is set (login GET vs public fallback). */
function mergeBrandingPreferFirst(primary, fallback) {
  const a = primary || {};
  const b = fallback || {};
  return {
    logo: trimStr(a.logo) || trimStr(b.logo) || "",
    primary_color:
      trimStr(a.primary_color) || trimStr(b.primary_color) || "",
    secondary_color:
      trimStr(a.secondary_color) || trimStr(b.secondary_color) || "",
  };
}

function isOkBrandingEnvelope(res) {
  const code = res?.data?.statusCode;
  return (
    res?.status === 200 &&
    res?.data?.data != null &&
    (code === "200" || code === 200)
  );
}

const DEFAULT_PRIMARY = "#59B3C6";
const DEFAULT_SECONDARY = "#000000";

const Login = (props) => {
  const dispatch = useDispatch();
  const authCtx = useContext(AuthContext);
  const [authToken, setAuthToken] = useState("");
  const [publicBrand, setPublicBrand] = useState(null);

  const pathname = window.location.pathname;
  const bgImg =
    "https://images.ctfassets.net/3s5io6mnxfqz/3pFLNqKgNyWiK1bitOJtXz/a2dda1332581395c121c866ea135b738/AdobeStock_192946304.jpeg";

  const loginContent = useSelector((state) => state.login.loginContent);

  useEffect(() => {
    setAuthToken(authCtx.auth);
  }, [setAuthToken, authCtx.auth, authToken]);

  useEffect(() => {
    dispatch(getLoginContent());
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getPublicTenantBranding();
        if (cancelled || !isOkBrandingEnvelope(res)) return;
        const parsed = normalizeLoginBrandingPayload(res.data.data);
        if (parsed) setPublicBrand(parsed);
      } catch (_) {
        /* ignore — rely on GET login / default logo */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const effectiveBranding = useMemo(() => {
    const fromLogin = normalizeLoginBrandingPayload(loginContent);
    return mergeBrandingPreferFirst(fromLogin, publicBrand);
  }, [loginContent, publicBrand]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--brand-primary",
      trimStr(effectiveBranding.primary_color) || DEFAULT_PRIMARY
    );
    document.documentElement.style.setProperty(
      "--brand-secondary",
      trimStr(effectiveBranding.secondary_color) || DEFAULT_SECONDARY
    );
  }, [effectiveBranding.primary_color, effectiveBranding.secondary_color]);

  let navigate = useNavigate();

  // const title = props.title;
  // useEffect(() => {
  //   if (!localStorage.getItem("userData")) {
  //     navigate("/");
  //   }
  // }, [title, navigate]);

  return (
    <div title={props.title}>
      <>
        <div className="flex relative min-h-full flex-1">
          <div className="flex flex-1 flex-col px-4 py-8 max-sm:p-0 sm:px-6 lg:flex-none lg:px-20 xl:px-24 h-[100vh] overflow-y-auto overflow-x-hidden listing">
            {pathname === "/" && false && (
              <div className="hidden max-sm:block bg-[var(--brand-primary)]">
                <img
                  className="relative inset-0 h-full mb-8 w-full object-cover opacity-[0.5]"
                  src={bgImg}
                  alt=""
                />
              </div>
            )}
            <div className="mx-auto my-auto max-sm:h-full items-center w-full max-w-sm lg:w-96 max-sm:px-4 max-sm:py-6">
              <div>
                <div className="flex">
                  <img
                    className="h-9 w-auto my-auto max-h-[70px] object-contain object-left"
                    src={trimStr(effectiveBranding.logo) || logo}
                    alt="Your Company"
                  />
                  {/* <h2 className="ms-2 text-[#59B3C6] font-[600] text-5xl">
                    Zoi
                  </h2> */}
                </div>
                {(pathname === "/" || pathname === "/checkemail") && (
                  <>
                    <h2 className="mt-8 max-sm:mt-2 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                      SIA(Smart Investment and Insurance Assistant)
                    </h2>
                    {/* <p className="mt-2 text-sm leading-6 text-gray-500">
                    powered by Zoi
                  </p> */}
                  </>
                )}
                {pathname === "/signup" && (
                  <>
                    <h2 className="mt-4 max-sm:mt-2 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                      New User Registration
                    </h2>
                  </>
                )}
                {pathname === "/forgetpassword" && (
                  <>
                    <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                      Reset your password
                    </h2>
                    <p className="mt-2 text-sm leading-6 text-gray-500">
                      Please enter the e-mail ID your Zoi account is registered
                      with.
                    </p>
                  </>
                )}
                {pathname === "/resetpassword" && (
                  <>
                    <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                      Create your new password
                    </h2>
                    <p className="mt-2 text-sm leading-6 text-gray-500">
                      Please create a new password.
                    </p>
                  </>
                )}
              </div>
              <Outlet></Outlet>
            </div>
          </div>
          <div className="relative max-sm:hidden h-screen w-0 max-sm:h-[25vh] max-sm:top-[100%] max-sm:w-full flex-1 lg:block bg-[var(--brand-primary)]">
            <img
              className="absolute inset-0 h-[70%] max-sm:h-full w-full object-cover opacity-[0.5]"
              src={bgImg}
              alt=""
            />
            <div className="w-[485px] max-sm:w-[300px] max-sm:bottom-6 max-sm:left-10 absolute bottom-10 left-20">
              <Carousel
                showThumbs={false}
                transitionTime={1000}
                autoPlay
                infiniteLoop
                showArrows={false}
                showIndicators={false}
                showStatus={false}
                swipeable
              >
                <div className="flex">
                  <div className="text-white my-auto mr-6 text-[22px]">
                    <Icon.Magic />
                  </div>
                  <div className="">
                    <div className="slider-title text-left ">
                    GET AI-GENERATED B2B LEADS
                    </div>
                    <div className="slider-heading text-left flex">
                    Identify Quality Leads
                    </div>
                    <div className="slider-desc ml-auto text-left">
                    Let AI deliver new leads right into your inbox. Discover growth opportunities right when the customer is ready.
                    </div>
                  </div>
                </div>
                <div className="flex">
                  <div className="text-white my-auto mr-6 text-[22px]">
                    <Icon.Magic />
                  </div>
                  <div className="">
                    <div className="slider-title text-left ">CUT THE NOISE</div>
                    <div className="slider-heading text-left flex">
                      Leverage Intelligent Signals
                    </div>
                    <div className="slider-desc ml-auto text-left">
                      Remove guesswork. Use AI signals to reach the right
                      account, at the right time with the right messages.{" "}
                    </div>
                  </div>
                </div>
                <div className="flex">
                  <div className="text-white my-auto mr-6 text-[22px]">
                    <Icon.Magic />
                  </div>
                  <div className="">
                    <div className="slider-title text-left ">
                    PERSONALISED ENGAGEMENT
                    </div>
                    <div className="slider-heading text-left flex">
                    Engage Better with Personalisation
                    </div>
                    <div className="slider-desc ml-auto text-left">
                    Differentiate your offerings. Let AI assist you with the key points and help you create a perfect pitch for Emails and LinkedIn.
                    </div>
                  </div>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Login;
